import React, { useState, useEffect } from "react"
import Swal from "sweetalert2"
import {URL} from "../../config"

const EditProduct = ({product, setEditing}) => {
	const [formData, setFormData] = useState(product)
    const [categories, setCategories] = useState([])

    useEffect(() => {
       fetch(`${URL}/categories`, {
           headers: {
               "x-auth-token": localStorage.getItem("token")
           }
       })
       .then(res => res.json())
       .then(data => {
            // console.log(data)
           setCategories(data)
       })
   }, [categories])

  const onChangeHandler = (e) => {
      setFormData({
          ...formData,
          [e.target.name]: e.target.value
      })
  }

  const handleFile = (e) => {
      // console.log(e.target.files[0])
      setFormData({
          ...formData,
          image: e.target.files[0]
      })
  }

  const onSubmitHandler = (e) => {
      // console.log(formData)
      e.preventDefault()
      let updatedProduct = new FormData()
      updatedProduct.append('name', formData.name)
      updatedProduct.append('description', formData.description)
      updatedProduct.append('categoryId', formData.categoryId)
      updatedProduct.append('price', formData.price)
      if(typeof formData.image === 'object') {
          updatedProduct.append('image', formData.image)
      }
      fetch(`${URL}/products/${formData._id}`, {
          method: "PUT",
          body: updatedProduct,
          headers: {
              "x-auth-token": localStorage.getItem('token')
          }
      })
      .then(res => res.json())
      .then(data => {
          Swal.fire({
              icon: 'success',
              text: data.message
          })
          setEditing(false)
          window.location.href="/"
      })
  }

  return(
    <form className="col-md-5 mx-auto"  encType="multipart/form-data" onSubmit={onSubmitHandler}>
    	<h3 className="mb-5">Edit Tour</h3>

        <div className="form-group">
            <label htmlFor="name">Name</label>
            <input type="text" name="name" id="name" className="form-control" value={formData.name} onChange={onChangeHandler} />
        </div>

        <div className="form-group">
            <label htmlFor="description">Description</label>
            <input type="text" name="description" id="description" className="form-control" value={formData.description} onChange={onChangeHandler} />
        </div>

        <div className="form-group">
            <label htmlFor="price">Price</label>
            <input type="number" name="price" id="price" className="form-control" value={formData.price} onChange={onChangeHandler} />
        </div>

        <div className="form-group">
            <label htmlFor="image">Image</label>
            <img src={`${URL}/${formData.image}`} alt="product" className="img-fluid"/>
            <input type="file" name="image" id="image" className="form-control" onChange={handleFile} />
        </div>

        <select className="form-control mb-3" name="categoryId" onChange={onChangeHandler}>
            { categories.map(category => {
                return(
                  category._id === formData.categoryId ?
                  <option value={category._id} key={category._id} selected>{category.name}</option> :
                  <option value={category._id} key={category._id}>{category.name}</option>
                )
            })}
        </select>

        <button className='btn btn-primary mr-2'>Save</button>
        <button className='btn btn-secondary' type="button" onClick={() => setEditing(false)}>Cancel</button>
    </form>       
  )
}

export default EditProduct